import { catchError, map } from 'rxjs/operators';
import { throwError, Subject, Observable, of, empty } from 'rxjs';

export class InputEvents{

	_debug : boolean = false;
	debug(msg: string){
		if(this._debug){
			console.log("InputEvents: "+msg);
		}
	}
	constructor(){
		this.debug("Constructing.");
	}
	_muted = false;
	mute(){
		this._muted = true;
	}	
	resized(){
		this.events$.next('resized');
	}
	unmute(){
		this._muted = false;
	}
	events$ = new Subject<any>();
	downTemplate(){
		if(this._muted){
			return;
		}
		this.events$.next('reinit_template_down');
	}
	upTemplate(){
		if(this._muted){
			return;
		}
		
		this.events$.next('reinit_template_up');
	}
	reinitTemplate(){
		if(this._muted){
			return;
		}
		
		this.events$.next('reinit_template');
	}
	panStart(){
		if(this._muted){
			return;
		}
		
		this.events$.next('panstart');
	}
	panEnd(){
		if(this._muted){
			return;
		}
		
		this.events$.next('panend');
	}
	panUp(){
		if(this._muted){
			return;
		}
		
		this.events$.next('panup');
	}
	panDown(){
		if(this._muted){
			return;
		}
		
		this.events$.next('pandown');
	}
	upClicked(){
		if(this._muted){
			return;
		}
		
		this.events$.next('up');
	}
	downClicked(){
		if(this._muted){
			return;
		}
		
		this.events$.next('down');
	}
	questionClicked(){
		if(this._muted){
			return;
		}
		
		this.events$.next('question');
	}
	backClicked(){
		if(this._muted){
			return;
		}
		
		this.events$.next('back');
	}
	menuClicked(){
		if(this._muted){
			return;
		}
		
		this.events$.next('menu');
	}
	confirmClicked(){
		if(this._muted){
			return;
		}
		
		this.events$.next('confirm');
	}
	scrollY(y : number){
		if(this._muted){
			return;
		}
		
		this.events$.next(y);
	}
	powerClicked(){
    	if(this._muted){
			return;
		}
		
		this.events$.next('power');
	}

	chimneyClicked(){
		if(this._muted){
			return;
		}

		this.events$.next('chimney');
	}
	dhwClicked(){
		if(this._muted){
		return;
		}

		this.events$.next('dhw');
	}

	heatingClicked(){
		if(this._muted){
			return;
		}

		this.events$.next('heating');
	}

	
}